import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { LibraryComponent } from './library.component';
import { HubComponent } from './hub/hub.component';
import { FileComponent } from './file/file.component';
import { MathJaxModule } from 'ngx-mathjax';
import { PresentationComponent } from './presentation/presentation.component';
import { GameComponent } from './game/game.component';

const routes = [
  { path: '', component: LibraryComponent, data: { animation: 'LibraryHub'} },
  { path: ':hub', component: HubComponent, data: { animation: 'LibraryTopic'} },
  { path: 'jeux/:id', component: GameComponent, data: { animation: 'LibraryTopic'} },
  { path: ':topic/:id', component: FileComponent, data: { animation: 'LibraryTopicDetail'} }
];

@NgModule({
  declarations: [
    LibraryComponent,
    HubComponent,
    FileComponent,
    GameComponent,
    PresentationComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    MathJaxModule.forChild()
  ],
  exports: [
    PresentationComponent
  ]
})
export class LibraryModule { }
